
import { createSlice } from '@reduxjs/toolkit'

export const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState: {
        plan: null,
        clientId: null,
    },
    reducers: {
        actionUpdateKeyValueSubscription: (state: any, action) => {
            // console.log("actionUpdateKeyValueSubscription", action.payload)
            const payload: any = action.payload;
            Object.keys(payload).map((key) => {
                state[key] = payload[key];
            })
        }
    },
})

export const selectStoreSubscription = (state: any) => state.subscription;

export const { actionUpdateKeyValueSubscription } = subscriptionSlice.actions
  
export default subscriptionSlice.reducer;